import type React from "react";
import { useState } from "react";
import type { Asset } from "utils/object";
import AssetUnretireModal from "./AssetUnretireModal";
import UnretireAssetButton from "./UnretireAssetButton";

interface UnretireAssetButtonWithModalProps {
  asset: Asset;
  onSuccess?: () => void;
}

export default function UnretireAssetButtonWithModal({
  asset,
  onSuccess,
}: UnretireAssetButtonWithModalProps): React.ReactElement {
  const [isUnretireModalOpen, setIsUnretireModalOpen] = useState(false);

  return (
    <>
      <AssetUnretireModal
        asset={asset}
        isOpen={isUnretireModalOpen}
        onClose={() => setIsUnretireModalOpen(false)}
        onSuccess={onSuccess}
      />
      <UnretireAssetButton onClick={() => setIsUnretireModalOpen(true)} />
    </>
  );
}
